import { render, staticRenderFns } from "./ldlePurchaseList.vue?vue&type=template&id=431f0a42&scoped=true"
import script from "./ldlePurchaseList.vue?vue&type=script&lang=js"
export * from "./ldlePurchaseList.vue?vue&type=script&lang=js"
import style0 from "./ldlePurchaseList.vue?vue&type=style&index=0&id=431f0a42&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431f0a42",
  null
  
)

export default component.exports